import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingSpinner from "./LoadingSpinner";

interface RequireAuthProps {
  children: React.ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      // Sauvegarder la page demandée pour rediriger après login
      navigate("/login", { 
        replace: true,
        state: { from: location.pathname }
      });
    }
  }, [isAuthenticated, loading, navigate, location]);

  if (loading) {
    return <LoadingSpinner message="Vérification de l'authentification..." />;
  }

  if (!isAuthenticated) {
    return null; // Ne rien afficher pendant la redirection
  }

  return <>{children}</>;
};

export default RequireAuth;

